import React from "react";
import { connect } from "react-redux";
import mainHelper, { apiCall } from "../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import ReactDOMServer from 'react-dom/server';
class UserComments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            loading: false,
            editLoading: false,
            editCommentId: null,
            editCommentText: ''
        };
    }

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleEditChange = (event) => {
        const { value } = event.target;
        this.setState({ editCommentText: value });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const { taskID } = this.props;
        this.setState({ loading: true });
        try {
            const response = await apiCall('business/tasks/comments/add', 'post', { task_id: taskID, comment: this.state.comment });
            await this.props.fetchTasks();
            this.setState({ loading: false, comment: '' });
            mainHelper.toastMessage('success', response.message);

        } catch (e) {
            this.setState({ loading: false });
        }
    }
    handleDelete = async (commentID) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/tasks/comments/delete/' + commentID, 'delete');
                    await this.props.fetchTasks();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Yorum başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    handleEditSubmit = async (commentId) => {
        this.setState({ editLoading: true });
        try {
            const response = await apiCall(`business/tasks/comments/update/${commentId}`, 'post', { comment: this.state.editCommentText });
            await this.props.fetchTasks();
            this.setState({ editLoading: false, editCommentId: null, editCommentText: '' });
            mainHelper.toastMessage('success', response.message);
        } catch (e) {
            this.setState({ editLoading: false });
        }
    }

    render() {
        const { comments, status, taskID } = this.props;
        const { loading,editLoading, editCommentId, editCommentText } = this.state;

        return (
            <div className="card">
                <div className="header">
                    <h2>Yorumlar</h2>
                    <h2>
                        <button onClick={() => {
                            var form = document.getElementById('addComment' + taskID);

                            if (form.classList.contains("d-none")) {
                                form.classList.remove("d-none");
                            } else {
                                form.classList.add("d-none");
                            }
                        }} style={{ border: "none", background: "none", float: "right" }}>
                            <i className="icon-plus" style={{ color: status }}></i>
                        </button>
                    </h2>
                </div>
            <form onSubmit={this.handleSubmit} id={"addComment" + taskID} className="d-none">
            <div className="body">
                <div className="form-group">
                    <div className="form-line">
                <textarea
                    name="comment"
                    id="comment"
                    className="form-control"
                    placeholder="Yorum giriniz"
                    onChange={this.handleChange}
                    value={this.state.comment}
                >
                </textarea>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="form-line">
                                {loading ? (
                                   <button className="btn btn-outline-primary btn-block" disabled={true} style={{ textAlign: "-webkit-center" }}>
                                        Lütfen Bekleyin...
                                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />
                                    </button>
                                ) : (
                                    <button type="submit" className="btn btn-outline-primary btn-block">
                                        Ekle
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
                <div className="body">
                    <div className="list-group">
                        {comments && comments.length > 0 ? comments.map(comment => (
                            <div key={comment.id} className="list-group-item list-group-item-action flex-column align-items-start">
                                <div className="d-flex w-100 justify-content-between">
                                    <h6 className="mb-1"><strong>{comment.user.name + ' ' + comment.user.surname}</strong></h6>
                                    <small>{mainHelper.dateFormat(comment.created_at)}</small>
                                </div>
                        {editCommentId === comment.id ? (
                    <div>
                    <textarea
                        className="form-control"
                        value={editCommentText}
                        onChange={this.handleEditChange}>
                    </textarea>
                        <div className="form-group text-center">
                            <div className="form-line">
                                {editLoading ? (
                                    <button className="btn btn-outline-primary btn-lg m-2" disabled={true} style={{ textAlign: "-webkit-center" }}>
                                        Lütfen Bekleyin...
                                        <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2" />
                                    </button>
                                ) : (
                                    <button className="btn btn-outline-primary btn-sm m-2"
                                            onClick={() => this.handleEditSubmit(comment.id)}>
                                        Güncelle
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                                ) : (
                                    <div>
                                        <p className="mb-1">
                                            {comment.comment}
                                        </p>
                                        <button className="btn btn-outline-secondary btn-sm"
                                                onClick={() => this.setState({
                                                    editCommentId: comment.id,
                                                    editCommentText: comment.comment
                                                })}>
                                            <i className="icon-note"></i>
                                        </button>
                                        <button onClick={() => this.handleDelete(comment.id)} type="button"
                                                className="btn btn-sm btn-outline-danger float-right js-sweetalert"
                                                title="Sil">
                                            <i className="icon-trash"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        )) : (
                            <div className="alert alert-warning text-center">Henüz yorum yapılmamış.</div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
    userCommentData: mailInboxReducer.userCommentData,
});

export default connect(mapStateToProps, {})(UserComments);
